import { Component } from 'react';
import VPricingDetailBaseItem from '../Domain/VPricingDetailBaseItem.js';
import VPricingDetailListTotalItem from '../Domain/VPricingDetailListTotalItem.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import AuthService from './authService.js';

class PricingDetailService extends Component {
  static async GetActualAssignmentFeeValue(opportunityId) {
    const url = `/api/PricingDetail/GetActualAssignmentFeeValue/${opportunityId}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  /* static async GetActualAssignmentFeeValue(pricingDetailId) {
     let url = `/api/PricingDetail/GetPricingDetail/` + pricingDetailId;
     return AuthService.getInstance().CallBackendFunction(url);
   }
 */
  static async GetPricingDetailByPricingId(pricingId) {
    const url = `/api/PricingDetail/GetPricingDetailByPricingId/${pricingId}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetPricingDetail(PricingDetailId, clearCache = false) {
    if (!PricingDetailId || PricingDetailId < 1) {
      return null;
    }
    const url = `/api/PricingDetail/GetPricingDetail/${PricingDetailId}?clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetPricingDetailList(pricingIds, clearCache = false) {
    if (!pricingIds || pricingIds.length === 0) {
      return [];
    }

    const searchParams = { Values: pricingIds };

    const url = `/api/PricingDetail/GetPricingDetailList?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async CopyPricingDetail(PricingId) {
    const url = `/api/PricingDetail/CopyPricingDetail/${PricingId}`;
    return AuthService.getInstance().CallBackendFunctionPost(url);
  }

  static async GetPricingDetailListTotals(PricingDetailId, clearCache = false) {
    const url = `/api/PricingDetail/GetPricingDetailListTotals/${PricingDetailId}?clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertPricingDetailListTotalsItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new VPricingDetailListTotalItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new VPricingDetailBaseItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ConvertDBSingleItem(item) {
    return new VPricingDetailBaseItem(item);
  }

  static Post(item) {
    const url = '/api/PricingDetail/PostPricingDetailByPricing';

    const stringItem = serviceHelper.ConvertAllPropertyToString(item);
    const json = JSON.stringify(stringItem);

    return AuthService.getInstance().CallBackendFunctionPost(url, json);
  }

  static CopyPricings(item) {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/PricingDetail/CopyPricingsAsync/',
      JSON.stringify(item)
    );
  }
}

export default PricingDetailService;
